import React from 'react';

// Shared Privacy Policy body. Used both on the standalone /privacy page and
// (potentially) in any embedded modal. NOTE: These are placeholder terms.
// Replace with final legal copy before launch.
export default function PrivacyContent() {
  return (
    <div className="space-y-5 text-sm leading-relaxed text-gray-300" data-testid="privacy-content">
      <section>
        <h3 className="text-white font-semibold mb-1">1. Overview</h3>
        <p>
          Promote Black Business (PBB) respects your privacy. This Privacy
          Policy explains what personal information we collect, how we use it,
          and the choices you have. It applies to the PBB website, apps, and
          the SMS and email programs we run on your behalf.
        </p>
      </section>

      <section>
        <h3 className="text-white font-semibold mb-1">2. Information We Collect</h3>
        <ul className="list-disc pl-5 space-y-1">
          <li><b>Account information</b> — name, email, phone, city.</li>
          <li><b>Activity</b> — businesses you visit, coupons you redeem, loyalty
            stamps, RSVPs, bids, and donations.</li>
          <li><b>Device data</b> — approximate location (for QR check-in), browser,
            and operating system.</li>
          <li><b>Payment metadata</b> — transaction ids returned by PayPal or
            Stripe. We never see or store your full card number.</li>
        </ul>
      </section>

      <section>
        <h3 className="text-white font-semibold mb-1">3. SMS Program</h3>
        <p>
          If you opt in during signup (or later in your profile), PBB may send
          transactional SMS messages — for example, when you win an auction,
          when your Deal Bin purchase is confirmed, or when your password is
          reset. Message frequency varies. Message and data rates may apply.
        </p>
        <p>
          You can opt out at any time by replying <b>STOP</b> to any PBB text,
          or by unchecking SMS notifications in your profile. Reply <b>HELP</b>
          for support. We do not sell or share your phone number with third-party
          marketers.
        </p>
      </section>

      <section>
        <h3 className="text-white font-semibold mb-1">4. How We Use Your Data</h3>
        <ul className="list-disc pl-5 space-y-1">
          <li>Provide the directory, auction, loyalty, and messaging features.</li>
          <li>Show you businesses and events relevant to your city and interests.</li>
          <li>Prevent fraud, enforce our Terms, and respond to legal requests.</li>
          <li>Improve PBB — aggregated, non-identifying analytics only.</li>
        </ul>
      </section>

      <section>
        <h3 className="text-white font-semibold mb-1">5. Sharing</h3>
        <p>
          We share limited data with vendors that help us operate PBB (payment
          processors, email/SMS providers, cloud storage) under contracts that
          restrict how they may use it. We may disclose information when
          required by law.
        </p>
      </section>

      <section>
        <h3 className="text-white font-semibold mb-1">6. Your Choices</h3>
        <ul className="list-disc pl-5 space-y-1">
          <li>Edit or delete your account at any time from Profile.</li>
          <li>Opt out of marketing emails via the unsubscribe link.</li>
          <li>Opt out of SMS by replying STOP or toggling the setting in Profile.</li>
        </ul>
      </section>

      <section>
        <h3 className="text-white font-semibold mb-1">7. Contact</h3>
        <p>
          Privacy questions can be sent to <a className="text-green-400 hover:underline" href="mailto:privacy@pbb.app">privacy@pbb.app</a>.
        </p>
      </section>

      <p className="text-xs text-gray-500 pt-2 border-t border-[#153b23]">
        Last updated: February 2026 · These placeholder terms will be replaced
        with the finalized legal language prior to public launch.
      </p>
    </div>
  );
}
